// src/components/ChatInterface.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import '../styles/ChatInterface.css';
import { FaImage } from 'react-icons/fa';

const API_URL = 'https://0futxzj42b.execute-api.us-east-2.amazonaws.com/dev/chat';

export default function ChatInterface() {
  const auth = useAuth();
  const [messages, setMessages] = useState([
    { role: 'system', content: 'Eres un asistente que puede analizar datos de eventos para oces, los datos que sabes son como contexto: - Asistentes al vive Latino: 161879, fueron 65 bandas y artistas, el 68% esta dispuesto a regresar y el el evento favorito del 59% de los asistentes, uno de los sponsors fue Amazon, la Huella de patrocinio fue Top of mind 25% y Share of mind 61%.' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const userMsg = { role: 'user', content: input };
    const convo = [...messages, userMsg];
    setMessages(convo);
    setInput('');
    setLoading(true);

    try {
      const token = auth.user?.id_token || auth.user?.access_token;
      if (!token) throw new Error('Por favor, inicia sesión.');

      const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ messages: convo }),
      });

      if (!res.ok) {
        if (res.status === 401) throw new Error('No autorizado. Vuelve a iniciar sesión.');
        throw new Error(`HTTP ${res.status}`);
      }

      const { content } = await res.json();
      setMessages(prev => [...prev, { role: 'assistant', content }]);

    } catch (err) {
      console.error(err);
      setMessages(prev => [...prev, { role: 'assistant', content: err.message }]);
    } finally {
      setLoading(false);
    }
  };

  const handleImageClick = () => fileInputRef.current?.click();
  const handleImageChange = e => {
    const file = e.target.files?.[0];
    if (file) setMessages(prev => [...prev, { role: 'user', content: `[Imagen: ${file.name}]` }]);
  };

  return (
    <div className="chat-container">
      {/* ✅ Header opcional */}
      <div className="chat-header">
        <div className="chat-title">Backstage AI</div>
        <div className="chat-subtitle">Asistente para análisis de eventos</div>
      </div>

      <div className="chat-messages">
        {messages.filter(m => m.role !== 'system').map((m, i) => (
          <div key={i} className={`message ${m.role === 'user' ? 'user' : 'assistant'}`}>
            {m.content}
          </div>
        ))}

        {/* ✅ typing indicator */}
        {loading && (
          <div className="typing">
            <span /><span /><span />
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      <div className="chat-input-container">
        <button onClick={handleImageClick} className="image-button" disabled={loading}>
          <FaImage />
        </button>

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleImageChange}
        />

        <input
          type="text"
          className="chat-input"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && sendMessage()}
          placeholder="Escribe tu consulta..."
          disabled={loading}
        />

        <button onClick={sendMessage} className="send-button" disabled={loading}>
          {loading ? 'Enviando...' : 'Enviar'}
        </button>
      </div>
    </div>
  );
}
